import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './assets/styles/tokens.css';
import './assets/styles/global.css';
import './assets/styles/colors.css';
import './assets/styles/typography.css';
import './assets/styles/layout.css';
import './assets/styles/buttons.css';
import './assets/styles/gm-theme.css';
import './assets/styles/player-theme.css';
import './assets/styles/public.css';
/* After the three themes, so it can read whichever accent it stands in. */
import './assets/styles/loader.css';
/* Last: print overrides must win over every screen stylesheet above. */
import './assets/styles/print.css';
import skillService from '@/services/skillService';
import { showError } from '@/utils/loaderUtils';
import { installSessionGuard } from '@/api/sessionGuard';
import { installActingCharacterHeader } from '@/api/actingCharacter';
import { initErrorReporting, installVueErrorHandler } from '@/observability/errorReporting';

async function bootstrap() {
    try {
        /* Before anything else can throw: a crash during cache warm-up or
         * mount is exactly the one worth hearing about. */
        initErrorReporting();
        /* The boot screen is already on the page — index.html renders it
         * inline, and mounting Vue into #app below replaces it. */

        /* Before the first request: the cache warm-up below is itself
         * authenticated and can be the call that discovers a dead token. */
        installSessionGuard();
        installActingCharacterHeader();

        // Ensure the skill cache is updated before app initialization
        try {
            await skillService.updateAllCaches();
        } catch (error) {
            console.error("Failed to update skill service cache:", error);
        }
        // Create and mount the app
        const app = createApp(App)
            .use(store)
            .use(router)
            .use(i18n);
            // .use(WebSocketPlugin, {url: import.meta.env.VITE_WS_BASE_URL})
        installVueErrorHandler(app);
        app.mount('#app');
    } catch (error) {
        console.error("Failed to initialize the app:", error);
        showError('app', 'Failed to load application.');
    }
}

// Run the bootstrap function
bootstrap();
